// Collection Filter Script
// This script handles the filter functionality for the collection page.
// It listens for changes in the filter form, fetches the filtered products,
// and updates the product grid without a full page reload.
// It also includes a reset button to clear all filters and return to the default view.
// Ensure this script is loaded after the DOM is fully loaded.
// This script assumes the presence of a form with id "FacetFiltersForm" and a product grid with class "grid-shop-coffee".
// It also assumes that the filter form uses standard HTML form elements (checkboxes, radio buttons, etc.)
// and that the server responds with a full HTML document containing the updated product grid and filter form.
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#FacetFiltersForm");
  const filterWrapper = document.querySelector(".collection-filter-wrapper");
  const filtersToggleBtn = document.querySelector(".filters-toggle-btn");
  const productGrid = document.querySelector(".grid-shop-coffee");

  if (!form || !productGrid) return;

  // Toggle filter panel
  if (filtersToggleBtn) {
    filtersToggleBtn.addEventListener("click", () => {
      filterWrapper.classList.toggle("filters-open");
      const label = filtersToggleBtn.querySelector(".button-label");
      if (label) {
        label.textContent = filterWrapper.classList.contains("filters-open") ? "Close Filter" : "Filter";
      }
    });
  }

  // Event: filter changed
  form.addEventListener("change", (e) => {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;

    // Start loading effect
    productGrid.style.opacity = "0.5";

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Replace product grid
        const newGrid = doc.querySelector(".grid-shop-coffee");
        if (newGrid) {
          productGrid.innerHTML = newGrid.innerHTML;
        }

        // Replace filter form to update filter states and counts
        const newForm = doc.querySelector("#FacetFiltersForm");
        if (newForm) {
          form.innerHTML = newForm.innerHTML;
        }

        // Reset opacity
        productGrid.style.opacity = "1";

        // Update URL
        window.history.pushState({}, "", url);
        
        // Enable "Clear all filters" button if filters are applied
        const clearFiltersBtn = document.getElementById("reset-filters-btn");
        const urlParams = new URLSearchParams(window.location.search);

        if (clearFiltersBtn) {
            if ([...urlParams.entries()].some(([key, val]) => key.startsWith("filter."))) {
                clearFiltersBtn.removeAttribute("disabled");
                clearFiltersBtn.classList.remove("is-disabled");
            } else {
                clearFiltersBtn.setAttribute("disabled", "disabled");
                clearFiltersBtn.classList.add("is-disabled");
            }
        }

      })
      .catch((err) => {
        console.error("Filter error:", err);
        productGrid.style.opacity = "1";
      });
  });
});

// Reset All Filters Button
const resetButton = document.getElementById("reset-filters-btn");
if (resetButton) {
  resetButton.addEventListener("click", () => {
    const productGrid = document.querySelector(".grid-shop-coffee");
    const baseUrl = window.location.pathname;

    // Optional: Add loading state
    if (productGrid) productGrid.style.opacity = "0.7";

    fetch(baseUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Replace product grid
        const newGrid = doc.querySelector(".grid-shop-coffee");
        if (newGrid && productGrid) {
          productGrid.innerHTML = newGrid.innerHTML;
        }

        // Replace filters
        const newForm = doc.querySelector("#FacetFiltersForm");
        const oldForm = document.querySelector("#FacetFiltersForm");
        if (newForm && oldForm) {
          oldForm.innerHTML = newForm.innerHTML;
        }

        // Reset opacity
        if (productGrid) productGrid.style.opacity = "1";

        // Disable "Clear all filters" button
        resetButton.setAttribute("disabled", "disabled");
        resetButton.classList.add("is-disabled");

        // Update browser URL
        window.history.pushState({}, "", baseUrl);
      })
      .catch((err) => {
        console.error("Reset filter error:", err);
        if (productGrid) productGrid.style.opacity = "1";
      });
  });
}

